import { PersonalInfo } from '@/models';

export interface PersonalInfoState {
  personalInfo: PersonalInfo | null
}

export const InitialState: PersonalInfoState = {
  personalInfo: null
}
